<div class="container-fluid">

  <div class="jumbotron tw-w-full tw-p-3  tw-m-0 bg-inverse bg-light-dark calculator">

    <!-- <h1 class="tw-text-center">Angular Calculator</h1> -->

    <!-- Displays the User Input -->
    <div class="input-group input-group-sm tw-w-full tw-m-0 tw-p-0  result">
      <div class="tw-w-full form-control text-lg-right fs-1" type="text">{{(input|numberSeparator)}}</div>
    </div>


    <!-- Displays the Results -->
    <!-- <div class="input-group input-group-sm tw-w-full tw-m-0 p-0">
        <div class="form-control text-sm-right" type="text">{{result}}</div>
      </div> -->
    <div class="tw-w-full tw-p-1  m-0">
      <div class="row">
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn border-field tw-w-full" [themeColor]="'btn'" type="button" (click)="pressOperator('/')">/</button>
        </div>
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-warning border-field tw-w-full" type="button" (click)="clear()">></button>
        </div>
        <div class="tw-w-1/2 tw-px-2">
          <button class="btn btn-danger border-field tw-w-full" type="button" (click)="allClear()">C</button>
        </div>
      </div>
    </div>
    <div class="tw-w-full tw-p-1  m-0">
      <div class="row">
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field tw-w-full" [themeColor]="'btn'" type="button"
            (click)="pressOperator('*')">x</button>
        </div>
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field btn-outline-secondary text-gray tw-w-full button-number" type="button"
            (click)="pressNum('9')">9</button>
        </div>
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field btn-outline-secondary text-gray tw-w-full button-number" type="button"
            (click)="pressNum('8')">8</button>
        </div>
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field btn-outline-secondary text-gray tw-w-full button-number" type="button"
            (click)="pressNum('7')">7</button>
        </div>
      </div>
    </div>
    <div class="tw-w-full tw-p-1  m-0">
      <div class="row">
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field tw-w-full" [themeColor]="'btn'" type="button"
            (click)="pressOperator('-')">-</button>
        </div>
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field btn-outline-secondary text-gray tw-w-full button-number" type="button"
            (click)="pressNum('6')">6</button>
        </div>
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field btn-outline-secondary text-gray tw-w-full button-number" type="button"
            (click)="pressNum('5')">5</button>
        </div>
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field btn-outline-secondary text-gray tw-w-full button-number" type="button"
            (click)="pressNum('4')">4</button>
        </div>
      </div>
    </div>
    <div class="tw-w-full tw-p-1  m-0">
      <div class="row">
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field tw-w-full" [themeColor]="'btn'" type="button"
            (click)="pressOperator('+')">+</button>
        </div>
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field btn-outline-secondary text-gray tw-w-full button-number" type="button"
            (click)="pressNum('3')">3</button>
        </div>
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field btn-outline-secondary text-gray tw-w-full button-number" type="button"
            (click)="pressNum('2')">2</button>
        </div>
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field btn-outline-secondary text-gray tw-w-full button-number" type="button"
            (click)="pressNum('1')">1</button>
        </div>
      </div>
    </div>
    <div class="tw-w-full tw-p-1  m-0">
      <div class="row">
        <div class="tw-w-1/2 tw-px-2">
          <button class="btn btn-lg border-field btn-success tw-w-full" type="button" (click)="getAnswer()">=</button>
        </div>
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field btn-outline-secondary text-gray tw-w-full button-number" type="button"
            (click)="pressNum('0')">0</button>
        </div>
        <div class="tw-w-1/4 tw-px-2">
          <button class="btn btn-lg border-field btn-outline-secondary text-gray tw-w-full button-number" type="button"
            (click)="pressNum('.')">.</button>
        </div>
      </div>
    </div>
  </div>
